export default "__VITE_ASSET__EmOMvOUj__"